import { Navigate, useLocation } from 'react-router-dom';

type LegacyExerciseEmailRedirectProps = {
  children: React.ReactNode;
};

export const isLegacyExerciseEmailLink = (search: string) =>
  new URLSearchParams(search).has('fcid');

/**
 * Exercise emails sent before the OTP portal migration linked to
 * `/login?fcid=...`. Once authentication finishes, preserve the email's
 * original intent by sending those patients to their exercises.
 */
export const LegacyExerciseEmailRedirect = ({ children }: LegacyExerciseEmailRedirectProps) => {
  const { search } = useLocation();

  return isLegacyExerciseEmailLink(search) ? <Navigate to="/exercises" replace /> : children;
};
